import { Routes, Route } from 'react-router-dom';
import { useEffect } from "react";
import { useDispatch } from 'react-redux';

import {
  onAuthStateChangedListener,
  createUserInDatabase,
} from "./utils/firebase/firebase.util";
import Home from "./routes/home/home.component";
import Navigation from './routes/navigation/navigation.component';
import Authentication from './routes/authentication/authentication.component';
import Shop from './routes/shop/shop.component';
import Checkout from './routes/checkout/checkout.component';
import { setCurrentUser } from './store/user/user.action';

const App = () => {
  const dispatch = useDispatch();

  // Tries to fetch the user on mount of the app
  useEffect(() => {
    const unsubscribe = onAuthStateChangedListener(( user ) => {
      if ( user ) {
        createUserInDatabase(user);
      }
      dispatch(setCurrentUser(user));
    });

    return unsubscribe;
  }, []);

  return (
    <Routes>
      <Route path="/" element={ <Navigation /> }>
        <Route index={true} element={ <Home /> } />
        <Route path="shop/*" element={ <Shop /> } />
        <Route path="auth" element={ <Authentication /> } />
        <Route path='checkout' element={ <Checkout /> } />
      </Route>
    </Routes>
  );
};

export default App;
